import { COLLECTIONS } from '../firebase/collections';

export const COLLECTION_PAGES = {
  contacts: {
    key: 'contacts',
    collection: COLLECTIONS.CONTACTS,
    title: 'Contact Messages',
    description: 'Contact Us form submissions from the mobile app',
    searchFields: ['email', 'subject', 'message', 'userUid'],
    columns: [
      { title: 'Email', dataIndex: 'email', key: 'email', ellipsis: true },
      { title: 'Subject', dataIndex: 'subject', key: 'subject', ellipsis: true },
      { title: 'Message', dataIndex: 'message', key: 'message', ellipsis: true },
      { title: 'User UID', dataIndex: 'userUid', key: 'userUid', ellipsis: true },
      { title: 'Created', dataIndex: 'createdAt', key: 'createdAt', type: 'date' },
    ],
  },
  conversations: {
    key: 'conversations',
    collection: COLLECTIONS.CONVERSATIONS,
    title: 'Conversations',
    description: 'User chat conversations',
    searchFields: ['id', 'userId', 'userUid', 'participantId', 'lastMessage', 'title'],
    columns: [
      { title: 'Title', dataIndex: 'title', key: 'title', ellipsis: true },
      { title: 'Last Message', dataIndex: 'lastMessage', key: 'lastMessage', ellipsis: true },
      { title: 'User', dataIndex: 'userId', key: 'userId', ellipsis: true },
      { title: 'Participant', dataIndex: 'participantId', key: 'participantId', ellipsis: true },
      { title: 'Updated', dataIndex: 'updatedAt', key: 'updatedAt', type: 'date' },
      { title: 'Created', dataIndex: 'createdAt', key: 'createdAt', type: 'date' },
    ],
  },
  blocks: {
    key: 'blocks',
    collection: COLLECTIONS.BLOCKS,
    title: 'Blocks',
    description: 'Users blocked by other users',
    searchFields: ['blockerId', 'blockedId', 'userId', 'userUid'],
    columns: [
      { title: 'Blocker', dataIndex: 'blockerId', key: 'blockerId', ellipsis: true },
      { title: 'Blocked', dataIndex: 'blockedId', key: 'blockedId', ellipsis: true },
      { title: 'User UID', dataIndex: 'userUid', key: 'userUid', ellipsis: true },
      { title: 'Created', dataIndex: 'createdAt', key: 'createdAt', type: 'date' },
    ],
  },
  favorites: {
    key: 'favorites',
    collection: COLLECTIONS.FAVORITES,
    title: 'Favorites',
    description: 'User favorite profiles',
    searchFields: ['userId', 'userUid', 'favoriteUserId', 'favoritedUserId'],
    columns: [
      { title: 'User', dataIndex: 'userId', key: 'userId', ellipsis: true },
      { title: 'Favorite User', dataIndex: 'favoriteUserId', key: 'favoriteUserId', ellipsis: true },
      { title: 'User UID', dataIndex: 'userUid', key: 'userUid', ellipsis: true },
      { title: 'Created', dataIndex: 'createdAt', key: 'createdAt', type: 'date' },
    ],
  },
  albums: {
    key: 'albums',
    collection: COLLECTIONS.ALBUMS,
    title: 'Albums',
    description: 'User photo albums',
    searchFields: ['userId', 'userUid', 'name', 'title'],
    columns: [
      { title: 'Name', dataIndex: 'name', key: 'name', ellipsis: true },
      { title: 'Title', dataIndex: 'title', key: 'title', ellipsis: true },
      { title: 'User', dataIndex: 'userId', key: 'userId', ellipsis: true },
      { title: 'Photos', dataIndex: 'photoCount', key: 'photoCount' },
      { title: 'Created', dataIndex: 'createdAt', key: 'createdAt', type: 'date' },
    ],
  },
  taps: {
    key: 'taps',
    collection: COLLECTIONS.TAPS,
    title: 'Taps',
    description: 'User tap interactions',
    searchFields: ['fromUserId', 'toUserId', 'userId', 'userUid'],
    columns: [
      { title: 'From', dataIndex: 'fromUserId', key: 'fromUserId', ellipsis: true },
      { title: 'To', dataIndex: 'toUserId', key: 'toUserId', ellipsis: true },
      { title: 'User UID', dataIndex: 'userUid', key: 'userUid', ellipsis: true },
      { title: 'Created', dataIndex: 'createdAt', key: 'createdAt', type: 'date' },
    ],
  },
  presence: {
    key: 'presence',
    collection: COLLECTIONS.PRESENCE,
    title: 'Presence',
    description: 'Online status and last seen data',
    searchFields: ['userId', 'userUid', 'status'],
    columns: [
      { title: 'User', dataIndex: 'userId', key: 'userId', ellipsis: true },
      { title: 'Online', dataIndex: 'online', key: 'online', type: 'boolean' },
      { title: 'Status', dataIndex: 'status', key: 'status' },
      { title: 'Last Seen', dataIndex: 'lastSeen', key: 'lastSeen', type: 'date' },
      { title: 'Updated', dataIndex: 'updatedAt', key: 'updatedAt', type: 'date' },
    ],
  },
  profileCards: {
    key: 'profileCards',
    collection: COLLECTIONS.PROFILE_CARDS,
    title: 'Profile Cards',
    description: 'User profile card data',
    searchFields: ['userId', 'userUid', 'username', 'displayName', 'bio'],
    columns: [
      { title: 'Username', dataIndex: 'username', key: 'username', ellipsis: true },
      { title: 'Display Name', dataIndex: 'displayName', key: 'displayName', ellipsis: true },
      { title: 'User UID', dataIndex: 'userUid', key: 'userUid', ellipsis: true },
      { title: 'Bio', dataIndex: 'bio', key: 'bio', ellipsis: true },
      { title: 'Updated', dataIndex: 'updatedAt', key: 'updatedAt', type: 'date' },
    ],
  },
  profileImageViews: {
    key: 'profileImageViews',
    collection: COLLECTIONS.PROFILE_IMAGE_VIEWS,
    title: 'Profile Image Views',
    description: 'Profile image view tracking',
    searchFields: ['viewerId', 'viewedUserId', 'userUid', 'profileUserId'],
    columns: [
      { title: 'Viewer', dataIndex: 'viewerId', key: 'viewerId', ellipsis: true },
      { title: 'Viewed User', dataIndex: 'viewedUserId', key: 'viewedUserId', ellipsis: true },
      { title: 'User UID', dataIndex: 'userUid', key: 'userUid', ellipsis: true },
      { title: 'Viewed At', dataIndex: 'viewedAt', key: 'viewedAt', type: 'date' },
      { title: 'Created', dataIndex: 'createdAt', key: 'createdAt', type: 'date' },
    ],
  },
};

export const COLLECTION_PAGE_LIST = Object.values(COLLECTION_PAGES);
